import { createServerFn } from "@tanstack/react-start";

import { TASK_STATUS, TASK_WHO } from "@onesolution/constants";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";

import { NOTIFICATIONS_COLUMNS } from "@onesolution/constants/monday/notifications";
import { mondayClient } from "@onesolution/monday/monday";
import {
	TagsFiltersParams,
	makeTagsFilters,
} from "@onesolution/utils/makeTagsFilters";
import { wrapWithUseQuery } from "..";

function filterByStatus<T extends { status: { label: string } }[]>(tasks: T) {
	return tasks.filter(
		(task) =>
			![TASK_STATUS.cancelled, TASK_STATUS.done].some(
				(status) => status === task.status.label,
			),
	) as T;
}

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.validator(TagsFiltersParams)
	.handler(async ({ context, data: { cursor, limit, ...data } }) => {
		const queryPArams = await makeTagsFilters(context, data);
		const tasksResult = await mondayClient.query.tasks(context, {
			cursor,
			limit,
			queryParams: queryPArams,
		});
		const notifs = await mondayClient.query.notifications(context, {
			onlyNotProcessed: true,
			columnIds: [NOTIFICATIONS_COLUMNS.pulseId],
		});

		const tasks = filterByStatus(tasksResult.items).map(({ who, ...task }) => ({
			...task,
			product: task.parentItem.name,
			canEditStatus: who.color !== TASK_WHO.altavia,
			operations: task.parentItem.briefs.linked_items,
			hasUnreadNotif: Boolean(notifs.find((n) => n.pulseId === task.id)),
			parentItem: undefined,
		}));

		return { cursor: tasksResult.cursor, items: tasks };
	});

const handlerCount = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.handler(async ({ context }) => {
		const tasks = await mondayClient.query.tasksCount(context, {
			queryParams: await makeTagsFilters(context),
		});

		return filterByStatus(tasks);
	});

export const getTasksFromServer = wrapWithUseQuery("tasks", handler);
export const getTasksCountFromServer = wrapWithUseQuery(
	"tasksCount",
	handlerCount,
);
